/**
 * <Mascot> — a bundled champion illustration (atom, L0.1).
 *
 * Renders one of the Masteur mascots (Zoé / Sam / Tina) at a variant (`main` / `happy` / `unhappy`), from
 * the bundled `assets/champions/*.png`. The maison equivalent of the legacy `ChampionImageM` for the
 * DS layer (no uri — these are static app assets, not server images like `<ImageIcon>`).
 */
import React from "react"
import { Image } from "react-native"
import { StyleSheet } from "react-native-unistyles"

import zoeMain from "../../../../assets/champions/zoe_main.png"
import zoeHappy from "../../../../assets/champions/zoe_happy.png"
import zoeUnhappy from "../../../../assets/champions/zoe_unhappy.png"
import samMain from "../../../../assets/champions/sam_main.png"
import samHappy from "../../../../assets/champions/sam_happy.png"
import samUnhappy from "../../../../assets/champions/sam_unhappy.png"
import tinaMain from "../../../../assets/champions/tina_main.png"
import tinaHappy from "../../../../assets/champions/tina_happy.png"
import tinaUnhappy from "../../../../assets/champions/tina_unhappy.png"

export type MascotName = "zoe" | "sam" | "tina"

const IMAGES: Record<MascotName, Record<string, number>> = {
    zoe: { main: zoeMain, happy: zoeHappy, unhappy: zoeUnhappy },
    sam: { main: samMain, happy: samHappy, unhappy: samUnhappy },
    tina: { main: tinaMain, happy: tinaHappy, unhappy: tinaUnhappy },
}

export type MascotProps = {
    /** Which mascot — defaults to `zoe`. */
    name?: MascotName
    /** Variant string (`main` / `happy` / `unhappy`); unknown → `main`. */
    variant?: string
    /** Square pixel size — defaults to 100. */
    size?: number
    testID?: string
}

export function Mascot(props: MascotProps) {
    const { name = "zoe", variant = "main", size = 100, testID } = props
    const set = IMAGES[name]
    const source = set[variant] ?? set.main

    return <Image testID={testID} source={source} style={styles.img(size)} resizeMode="contain" />
}

const styles = StyleSheet.create(() => ({
    img: (size: number) => ({
        width: size,
        height: size,
    }),
}))
